import type * as React from 'react';

/**
 * Full-viewport loading splash rendered by `RootGate` / `AuthedLayout` /
 * `LandingRoute` while the principal + maintenance status queries are
 * in flight. Centered Cotality mark + a CSS-only spinner — no React Query
 * dependency, no router context required, no portals; safe to render
 * anywhere in the tree including before `<RouterProvider/>` mounts.
 */
export function LoadingScreen(): React.ReactElement {
  return (
    <output
      aria-live="polite"
      aria-label="Loading Cotality Marketplace"
      className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background text-foreground"
    >
      <div className="flex items-center gap-3">
        <img
          src="/cotality-logomark.png"
          alt=""
          aria-hidden="true"
          className="h-8 w-8 dark:invert"
        />
        <span className="text-xl font-semibold tracking-tight">Cotality Marketplace</span>
      </div>
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary"
        aria-hidden="true"
      />
    </output>
  );
}
